(() => {
  const configElement = document.getElementById('festfloor-movember-config');
  if (!configElement || window.festfloorMovember) return;
  const config = JSON.parse(configElement.textContent);
  const originalFetch = window.fetch.bind(window);
  const eligible = new Set(config.eligibleProductIds.map(String));
  const marker = '_festfloor_promotion';
  const campaign = 'movember-2026';
  const root = config.root.replace(/\/?$/, '/');
  let queue = Promise.resolve();
  let refreshing = false;
  let replayingCheckout = false;
  const testMode = config.preview && Date.now() < Date.parse(config.startsAt);
  let declinedCart = null;
  const active = () => testMode || (Date.now() >= Date.parse(config.startsAt) && Date.now() < Date.parse(config.endsAt));
  const managed = item => item.properties && item.properties[marker] === campaign;
  const gift = item => String(item.variant_id) === String(config.giftVariantId);
  const request = async (path, body) => {
    const response = await originalFetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    } : {cache: 'no-store'});
    if (!response.ok) throw new Error(`Movember cart request failed: ${response.status}`);
    return response.json();
  };
  const serialized = task => {
    const result = queue.then(task, task);
    queue = result.catch(error => console.warn('[Movember]', error.message));
    return result;
  };
  let feedbackTimer;
  function giftFeedback(state) {
    clearTimeout(feedbackTimer);
    document.body.classList.toggle('movember-gift-visible', Boolean(state));
    if (!state) return;
    document.body.classList.toggle('movember-gift-pending', state === 'pending');
    document.body.classList.toggle('movember-gift-added', state === 'added');
    if (state === 'added') feedbackTimer = setTimeout(() => giftFeedback(null), 4000);
  }
  async function reconcile(sections = [], openDrawer = false) {
    try { return await reconcileCart(sections, openDrawer); }
    finally {
      if (document.body.classList.contains('movember-gift-pending')) giftFeedback(null);
    }
  }
  async function reconcileCart(sections = [], openDrawer = false) {
    let cart = await request('cart.js');
    let changed = false;
    const qualifies = active() && cart.items.some(item => eligible.has(String(item.product_id)) && item.quantity > 0);
    const needsGift = qualifies && !cart.items.some(gift);
    if (needsGift) {
      giftFeedback('pending');
      if (openDrawer) {
        const drawer = document.getElementById('t4s-mini_cart');
        if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') {
          document.querySelector('[data-drawer-options*="t4s-mini_cart"]')?.click();
        }
      }
    }
    if (config.previewDiscountCode) {
      const existingCodes = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
      const codes = existingCodes.filter(code => code.toLowerCase() !== 'movember-qa-203804737863');
      const hasTestCode = codes.some(code => code.toLowerCase() === config.previewDiscountCode.toLowerCase());
      if (testMode && qualifies && (!hasTestCode || codes.length !== existingCodes.length)) {
        cart = await request('cart/update.js', {discount: [...codes, config.previewDiscountCode].join(',')});
        changed = true;
      } else if (!testMode && hasTestCode) {
        cart = await request('cart/update.js', {discount: codes.filter(code => code.toLowerCase() !== config.previewDiscountCode.toLowerCase()).join(',')});
        changed = true;
      }
    }
    const gifts = cart.items.filter(gift);
    const updates = {};
    if (!qualifies) {
      gifts.filter(managed).forEach(item => { updates[item.key] = 0; });
    } else if (gifts.length) {
      const keep = gifts[0];
      if (keep.quantity !== 1) updates[keep.key] = 1;
      gifts.slice(1).forEach(item => { updates[item.key] = 0; });
    } else if (declinedCart !== JSON.stringify(cart.items.map(item => [item.key, item.quantity]))) {
      const product = await request(`products/${config.giftHandle}.js`);
      const variant = product.variants.find(item => String(item.id) === String(config.giftVariantId));
      if (variant && variant.available) {
        await request('cart/add.js', {items: [{id: config.giftVariantId, quantity: 1, properties: {[marker]: campaign}}]});
        changed = true;
        cart = await request('cart.js');
      }
    }
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      changed = true;
    }
    const paidGifts = cart.items.filter(item => gift(item) && managed(item) && item.final_line_price > 0);
    if (paidGifts.length) {
      cart = await request('cart/update.js', {updates: Object.fromEntries(paidGifts.map(item => [item.key, 0]))});
      declinedCart = JSON.stringify(cart.items.map(item => [item.key, item.quantity]));
      changed = true;
    }
    let rendered;
    if (changed && sections.length) {
      const url = new URL(location.href);
      url.searchParams.set('sections', sections.join(','));
      const response = await originalFetch(url, {cache: 'no-store'});
      if (response.ok) rendered = await response.json();
    }
    if (needsGift && cart.items.some(item => gift(item) && item.final_line_price === 0)) giftFeedback('added');
    return {cart, changed, sections: rendered};
  }
  function refresh() {
    if (refreshing) return;
    refreshing = true;
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(() => { refreshing = false; }, 300);
  }
  window.fetch = function(input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = (options && options.method || input.method || 'GET').toUpperCase();
    if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname)) {
      return originalFetch(input, options);
    }
    return serialized(async () => {
      const response = await originalFetch(input, options);
      if (!response.ok) return response;
      try {
        const data = await response.clone().json();
        const result = await reconcile(Object.keys(data.sections || {}), true);
        if (!result.changed) return response;
        const body = /\/add(\.js)?\/?$/.test(url.pathname) ? data : {...data, ...result.cart};
        if (result.sections) body.sections = result.sections;
        else setTimeout(refresh, 0);
        const headers = new Headers(response.headers);
        headers.delete('content-length');
        headers.delete('content-encoding');
        return new Response(JSON.stringify(body), {status: response.status, statusText: response.statusText, headers});
      } catch (error) {
        console.warn('[Movember]', error.message);
        return response;
      }
    });
  };
  const sync = () => serialized(() => reconcile()).then(result => {
    if (result.changed) refresh();
    return result;
  });
  window.festfloorMovember = {sync, testMode};
  document.addEventListener('cart:updated', () => { if (!refreshing) sync().catch(() => {}); });
  window.addEventListener('pageshow', () => sync().catch(() => {}));
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!button || replayingCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync().then(() => {
      replayingCheckout = true;
      button.click();
      replayingCheckout = false;
    }).catch(() => { replayingCheckout = true; button.click(); replayingCheckout = false; });
  }, true);
  sync().catch(() => {});
})();
